/* eslint-disable */
import { SIDEBAR_RIGHT_CLOSE } from '../Sidebar.types';

/**
 * Close the sidebar
 * @returns {ActionCreator<FromPayload<null, {}, SIDEBAR_RIGHT_CLOSE>>} The created `Action`
 */
const sidebarRightClose = () => ({ fromPayload }) => {
  return fromPayload(null, {}, SIDEBAR_RIGHT_CLOSE);
};

export default sidebarRightClose;
